import React, { useRef, useState, useEffect, useCallback } from 'react';
import { RotateCcw } from 'lucide-react';
import { Button } from '@cargomatic/ui';
export function FilterBar({ children, onReset }) {
    const scrollRef = useRef(null);
    const [showRightFade, setShowRightFade] = useState(false);
    const checkScroll = useCallback(() => {
        const el = scrollRef.current;
        if (!el)
            return;
        const { scrollLeft, scrollWidth, clientWidth } = el;
        setShowRightFade(scrollLeft < scrollWidth - clientWidth - 1);
    }, []);
    useEffect(() => {
        const el = scrollRef.current;
        if (!el)
            return;
        checkScroll();
        el.addEventListener('scroll', checkScroll);
        const observer = new ResizeObserver(checkScroll);
        observer.observe(el);
        return () => {
            el.removeEventListener('scroll', checkScroll);
            observer.disconnect();
        };
    }, [checkScroll]);
    return (React.createElement("div", { role: "search", "aria-label": "Filters", className: "flex items-end bg-muted/50 rounded-md py-2 px-3 relative" },
        React.createElement("style", null, `
        .filter-bar-thin-scrollbar::-webkit-scrollbar { height: 4px; }
        .filter-bar-thin-scrollbar::-webkit-scrollbar-thumb {
          background: rgba(0,0,0,0.25);
          border-radius: 2px;
        }
        .filter-bar-thin-scrollbar::-webkit-scrollbar-track {
          background: transparent;
        }
        @media (pointer: coarse) {
          .filter-bar-thin-scrollbar { scrollbar-width: none; }
          .filter-bar-thin-scrollbar::-webkit-scrollbar { display: none; }
        }
      `),
        React.createElement("div", { ref: scrollRef, className: "flex items-end gap-2 overflow-x-auto flex-1 min-w-0 flex-nowrap filter-bar-thin-scrollbar", style: { scrollbarWidth: 'thin' } }, children),
        showRightFade && (React.createElement("div", { className: "absolute right-12 top-0 bottom-0 w-8 bg-gradient-to-l from-muted/50 to-transparent pointer-events-none" })),
        onReset && (React.createElement("div", { className: "shrink-0 ml-2 pl-2 border-l flex items-end" },
            React.createElement(Button, { variant: "outline", size: "sm", onClick: onReset, className: "h-8 px-2 gap-1.5 text-xs whitespace-nowrap" },
                React.createElement(RotateCcw, { className: "size-3" }),
                "Reset")))));
}
